<template>
  <gkModal
    gkmodal-color="offlinepay"
    class="sign"
    :value="visible"
    v-model="visible"
    @close="close"
    transition="gk-fade-up"
    :needClose="closeable"
    loading
  >
    <div :class="$style.title">线下支付付款信息</div>

    <slot name="cashier" />

    <div :class="$style.info">
      <div :class="$style['info-name']">{{ offlinePayInfo.name }}</div>
      <div :class="$style['info-account']">{{ offlinePayInfo.account }}</div>
      <div :class="$style['info-desc']">
        <div>{{ offlinePayInfo.bank }}</div>
        <div>{{ offlinePayInfo.company }}</div>
      </div>

      <div :class="$style['info-bottom']">
        {{ offlinePayInfo.mark }}
      </div>
    </div>

    <div :class="$style['info-mark']">
      <!-- <div>备注：企业名称+购票人姓名</div> -->
      <div>可在小程序 <span :class="$style.link">我的活动-我报名的活动-待交费</span> 分类中查看线下付款信息</div>
    </div>

    <div :class="$style.btn" @click="copyInfo">复制信息</div>

    <div slot="footer"></div>
  </gkModal>
</template>

<script>
import gkModal from 'gkSrc/v2/modal'

import VueTypes from 'vue-types'
import utils from '../../util'

import { offlinePayInfo } from '../../service/basicData'

// import { mapState } from 'vuex'

export default {
  data () {
    return {
      visible: false,

      offlinePayInfo: Object.freeze(offlinePayInfo) // 线下付款信息
    }
  },
  props: {
    closeable: VueTypes.bool.def(true)
  },
  computed: {
    // ...mapState([
    //   'isMobile'
    // ])
  },
  components: {
    gkModal
  },
  methods: {
    /**
     * public
     * 显示设置弹框
     */
    show (data = {}) {
      this.visible = true
    },
    /**
     * public
     * 关闭设置弹框
     */
    close (emitType) {
      this.visible = false
    },
    /**
     * 确定
     */
    handleConfirm () {
      this.close()

      this.$emit('confirm')
    },
    handleClose () {
      this.close()

      this.$emit('close')
    },

    copyInfo () {
      return utils.copy(offlinePayInfo.account.replaceAll(' ', ''))
    }
  },
  created () {},
  mounted () {}
}
</script>

<style lang="scss" module>
@import '../../style/bulma/app.sass';
@import '~@geekbang/geek.ui/src/v2/modal/base';

@include appendGkModalColor('offlinepay') {
  & [gk-modal-main] {
    box-sizing: border-box;
    width: 494px;
    padding: 26px 30px 30px;
    border-radius: 8px;
    @include mobile {
      width: 72.2vw;
      padding: 20px 0 22px;
      transform: translate3d(0, calc(-50% - 71px), 0) !important;
      border-radius: 5px;
      text-align: center;
    }
  }

  & [gk-modal-close] {
    top: 17px; right: 22px;
    @include mobile {
       top: 2px; right: 2px;
    }
    &::before, &::after {
      width: 20px;
      @include mobile {
        width: 14px;
      }
    }
  }
}

.title {
  margin-bottom: 20px;
  font-size: 16px; font-weight: 700;
  line-height: 1;
}
.info {
  box-sizing: border-box;
  position: relative;
  height: 202px;
  padding: 18px 16px 0;
  background: url('https://static001.geekbang.org/resource/image/50/a7/50e812ef0e34ff974403e6d963d52fa7.png') top right / 205px 128px no-repeat;
  border-radius: 4px;
  border: 1px solid #E8E8E8;
  color: $color-text-dark2;
}
.info-name {
  font-size: 16px; font-weight: 600;
  line-height: 1;
}
.info-account {
  margin: 1px 0 24px;
  font-family: DINAlternateBold;
  font-size: 30px; font-weight: 600;
}
.info-desc {
  line-height: 1.5;
}
.info-bottom {
  position: absolute; left: 0; right: 0; bottom: 0;
  padding: 0 16px;
  height: 40px;
  border-top: 1px solid #ebebeb;
  border-radius: 0 0 8px 8px;
  line-height: 40px;
}
.info-mark {
  margin: 12px 0 18px;
  font-size: 12px;
  color: $color-gray-2;
  line-height: 19px;
  .link {
    color: $color-orange3;
  }
}
.btn {
  display: flex; justify-content: center;
  width: 230px;
  height: 40px;
  margin: 0 auto;
  background: $primary3;
  border-radius: 4px;
  font-weight: 500;
  color: $color-orange2;
  text-align: center;
  line-height: 40px;
  cursor: pointer;

  @include mobile {
    border-radius: 20px;
  }
}

</style>
